import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ContactMessageCard from "./ContactMessageCard";
import { Variables } from "../../Variations/Variations";

export default function ContactViewPage() {
  const { id } = useParams(); // Route like: /contact/:id
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const numericId = useMemo(() => Number(id) || 0, [id]);

  const fetchContact = async (signal) => {
    setStatus("loading");
    setError(null);
    try {
      const res = await fetch(
        `${Variables.API_URL}Rasha/Contact/Get/${numericId}`,
        {
          method: "GET",
          headers: { Accept: "application/json" },
          signal,
        }
      );
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      const json = await res.json();
          // Adjust CreatedDate from UTC to local with timezone offset
    if (json.CreatedDate) {
       const utcDate = new Date(json.CreatedDate);
       const offsetMinutes = new Date().getTimezoneOffset(); // minutes behind UTC
       // subtract offset → shift UTC to local
       const localDate = new Date(utcDate.getTime() - offsetMinutes * 60000);
       json.CreatedDate = localDate.toISOString();
     }
      setData(json);
      setStatus("success");
    } catch (err) {
      if (err.name === "AbortError") return; // ignore race
      setError(err.message || "Unknown error");
      setStatus("error");
    }
  };

  useEffect(() => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    if (numericId > 0) fetchContact(controller.signal);
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numericId]);

  return (
    <div style={{ padding: "20px" }}>
      <div className="d-flex justify-content-between">
 <h4
        style={{
          margin: "0px 0px 16px 25px",
          fontFamily:
            "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
        }}
      >
        Contact #{numericId || "—"}
      </h4>
       <button
        onClick={() => navigate("/admin/rasha/Contact")}
        style={{
          background: "#e2e8f0",
          color: "#1e293b",
          border: "1px solid #cbd5e1",
          padding: "6px 12px",
          borderRadius: 8,
          cursor: "pointer",
          marginBottom: 16,
        }}
      >
        ← Back
      </button>
      </div>
     

     

      {status === "loading" && <SkeletonCard />}
      {status === "error" && (
        <ErrorState
          message={error}
          onRetry={() => {
            abortRef.current?.abort();
            const c = new AbortController();
            abortRef.current = c;
            fetchContact(c.signal);
          }}
        />
      )}
      {status === "success" && data && <ContactMessageCard data={data} />}
    </div>
  );
}

function SkeletonCard() {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: "24px auto",
        borderRadius: 16,
        border: "1px solid #eee",
        background: "#fff",
        padding: 22,
      }}
    >
      <div
        style={{
          height: 18,
          width: 160,
          background: "#eef2f7",
          borderRadius: 8,
        }}
      />
      <div
        style={{
          marginTop: 12,
          height: 12,
          width: "60%",
          background: "#eef2f7",
          borderRadius: 8,
        }}
      />
      <div
        style={{
          marginTop: 12,
          height: 12,
          width: "40%",
          background: "#eef2f7",
          borderRadius: 8,
        }}
      />
      <div
        style={{
          marginTop: 20,
          height: 90,
          width: "100%",
          background: "#eef2f7",
          borderRadius: 12,
        }}
      />
    </div>
  );
}

function ErrorState({ message, onRetry }) {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: "24px auto",
        borderRadius: 16,
        border: "1px solid #fee2e2",
        background: "#fff1f2",
        color: "#7f1d1d",
        padding: 22,
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 8 }}>
        Failed to load contact
      </div>
      <div style={{ marginBottom: 12 }}>{String(message)}</div>
      <button
        onClick={onRetry}
        style={{
          background: "#1D4ED8",
          color: "#fff",
          border: "none",
          padding: "8px 12px",
          borderRadius: 10,
          cursor: "pointer",
        }}
      >
        Retry
      </button>
    </div>
  );
}
